// Externals

import { useSelector } from "react-redux";

// Hooks

// Styles
import "./ProgressBone.scss";
import colors from "../styles/index.scss";

// Constants

// ProgressBone component
const ProgressBone = (props) => {
	const foreground /*: number */ = useSelector(
		(state) => state.navigation.theme.foreground,
	);

	const foregroundColor = colors[foreground];

	// const surveyStep = useSelector((state) => state.navigation.surveyStep);

	const surveyStep = props.step;

	// Temporary for working purposes

	return (
		<div className="progress-bone">
			<h3>RSPCA COMPETIBLE</h3>
			<svg width="325px" height="25px" viewBox="0 0 325 25" version="1.1">
				<defs>
					<linearGradient id="left-to-right">
						<stop offset="0" stopColor="#fefefe">
							<animate
								id="gradient1"
								attributeName="offset"
								fill="freeze"
								from="0"
								to="1"
							/>
						</stop>
						<stop offset="0" stopColor={foregroundColor}>
							<animate
								id="gradient2"
								attributeName="offset"
								fill="freeze"
								from="0"
								to="1"
							/>
						</stop>
					</linearGradient>
				</defs>
				<g>
					<polygon
						id="b1"
						fill={surveyStep >= 1 ? "#fff" : "transparent"}
						stroke="#FEFEFE"
						points="6.30012626 0.618538052 1 5.13867211 1 9.87407283 3.81104718 12.413474 1 14.9533411 1 19.6887418 6.30012626 24.2088759 13.4211662 22.3436974 17.8043124 17.8627027 64.1812326 17.8627027 64.1812326 6.96471121 17.8043124 6.96471121 13.4211662 2.48278466"
					></polygon>
					<rect
						id="b2"
						fill={surveyStep >= 2 ? "#fff" : "transparent"}
						stroke="#FEFEFE"
						x="66.5"
						y="7"
						width="62"
						height="11"
					></rect>
					<rect
						id="b3"
						fill={surveyStep >= 3 ? "#fff" : "transparent"}
						stroke="#FEFEFE"
						x="131.5"
						y="7"
						width="62"
						height="11"
					></rect>
					<rect
						id="b4"
						fill={surveyStep >= 4 ? "#fff" : "transparent"}
						stroke="#FEFEFE"
						x="196.5"
						y="7"
						width="62"
						height="11"
					></rect>
					<polygon
						id="b5"
						fill={surveyStep >= 5 ? "#fff" : "transparent"}
						stroke="#FEFEFE"
						points="318.971421 0.618538052 311.850847 2.48278466 307.467235 6.96471121 261.172787 6.96471121 261.172787 17.8627027 307.467235 17.8627027 311.850847 22.3436974 318.971421 24.2088759 324.272014 19.6887418 324.272014 14.9533411 321.460035 12.413474 324.272014 9.87407283 324.272014 5.13867211"
					></polygon>
				</g>
			</svg>
		</div>
	);
};

// Exports
export default ProgressBone;
